import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../_services";
import { SharedService } from "../../_services";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html'
})

export class LogoutComponent implements OnInit {

    constructor(private _router: Router,
        private _authService: AuthService,
        private _sharedService: SharedService
    ) {
    }

    ngOnInit(): void {
        this._sharedService.emitLoad(true);
        // reset login status
        this._authService.logout();
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this._router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/auth/logout/logout.component.ts